/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useContext } from 'react';
import { useDropzone } from 'react-dropzone';

import { Typography, Box } from '@material-ui/core';
import FilterIcon from '@mui/icons-material/Filter';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { Dropzone, DropzoneActiveContainer, TextBox } from './styles';
import { GeneralContext } from '../../../../core/app-context/GeneralContext';

import propTypes from 'prop-types';

function processFileUploadError(error) {
  if (error.code === 'file-invalid-type') {
    return 'Tipo de arquivo inválido';
  }
  if (error.code === 'file-too-large') {
    return 'Arquivo muito grande';
  }
  return 'Erro ao processar arquivo';
}

/**
 * @param Object acceptedFilesTypes: Object must have the following structure (example):
 * {
 *   'image/png': ['.png'],
 *   'text/html': ['.html', '.htm'],
 * }
 */
export function FileDropzone({
  fileUrl,
  file,
  setFile,
  maxSize,
  acceptedFilesTypes,
}) {
  const { setErrorMessage } = useContext(GeneralContext);

  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length > 0) {
      const { errors } = fileRejections[0];
      errors?.forEach((error) =>
        setErrorMessage(processFileUploadError(error)),
      );
    } else {
      setFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    maxSize,
    accept: acceptedFilesTypes,
  });

  return (
    <Dropzone {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <Typography style={{ fontSize: '14px', color: '#616161' }}>
          Arraste o arquivo aqui...
        </Typography>
      ) : (
        <DropzoneActiveContainer>
          {(() => {
            if (file) {
              return (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {!!fileUrl ? (
                    <img alt="" src={fileUrl} height="30px" />
                  ) : (
                    <FilterIcon style={{ color: '#616161' }} />
                  )}
                  <ArrowForwardIcon
                    style={{ margin: '0 10px', color: '#616161' }}
                  />
                  <img alt="" src={URL.createObjectURL(file)} height="30px" />
                </Box>
              );
            } else {
              return !!fileUrl ? (
                <img alt="" src={fileUrl} height="30px" />
              ) : (
                <FilterIcon style={{ color: '#616161' }} />
              );
            }
          })()}
          <TextBox>
            <Typography style={{ fontSize: '10px', color: '#616161' }}>
              {fileUrl !== '' ? 'Alterar imagem' : 'Adicionar Imagem'}
            </Typography>
          </TextBox>
        </DropzoneActiveContainer>
      )}
    </Dropzone>
  );
}

FileDropzone.propTypes = {
  setFile: propTypes.func.isRequired,
  maxSize: propTypes.number,
};
